import { Div, Text1 } from "components/Base";
import React from "react";

const CONTAINER_STYLE = { gap: "20px" };

const OPTION_BASE_STYLE = {
  borderBottom: `1px solid`
};

const InputTypeSwitcher = ({ isUsingDraw, switchToDraw, switchToType }) => (
  <Div display="row.flex-start.center" style={CONTAINER_STYLE} mb={3}>
    <Text1
      pb={1}
      style={{
        ...OPTION_BASE_STYLE,
        borderBottomColor: isUsingDraw ? "#c9d7f6" : "white"
      }}
      onClick={switchToDraw}
    >
      Draw
    </Text1>
    <Text1
      pb={1}
      style={{
        ...OPTION_BASE_STYLE,
        borderBottomColor: !isUsingDraw ? "#c9d7f6" : "white"
      }}
      onClick={switchToType}
    >
      Type
    </Text1>
  </Div>
);

export default InputTypeSwitcher;
